import gql from "graphql-tag";
// import { SCREEN_FIELDS } from "@/apollo/queries/md/canales";

export const CREATE_SCREEN = gql`
  mutation savePantalla(
    $nombre_pantalla: String!
    $descripcion_pantalla: String!
    $codigo: String!
    $ubicacion: String!
    $zona_horaria: String!
    $id_canal: [Int]!
    $id_dispositivo: Int!
  ) {
    SavePantalla(
      nombre_pantalla: $nombre_pantalla
      descripcion_pantalla: $descripcion_pantalla
      codigo: $codigo
      ubicacion: $ubicacion
      zona_horaria: $zona_horaria
      id_canal: $id_canal
      id_dispositivo: $id_dispositivo
    ) {
      id_pantalla
      nombre_pantalla
      ubicacion
      zona_horaria
      codigo
      estado {
        id_estado
        nombre_estado
        color
      }
      canal {
        id_canal
        nombre_canal
        descripcion_canal
        cantidad_pantallas
      }
    }
  }
`;

export const UPDATE_SCREEN = gql`
  mutation UpdatePantalla(
    $nombre_pantalla: String!
    $descripcion_pantalla: String!
    $codigo: String!
    $ubicacion: String!
    $zona_horaria: String!
    $id_canal: [Int]!
    $id_pantalla: Int!
  ) {
    UpdatePantalla(
      nombre_pantalla: $nombre_pantalla
      descripcion_pantalla: $descripcion_pantalla
      codigo: $codigo
      ubicacion: $ubicacion
      zona_horaria: $zona_horaria
      id_canal: $id_canal
      id_pantalla: $id_pantalla
    ) {
      id_pantalla
      nombre_pantalla
      ubicacion
      zona_horaria
      codigo
      estado {
        id_estado
        nombre_estado
        color
      }
      canal {
        id_canal
        nombre_canal
        descripcion_canal
      }
    }
  }
`;

export const CHANGE_SCREEN_STATE = gql`
  mutation UpdateEstadoDispositivo(
    $codigo: String!
    $id_estado_dispositivo: Int!
  ) {
    UpdateEstadoDispositivo(
      codigo: $codigo
      id_estado_dispositivo: $id_estado_dispositivo
    ) {
      id_dispositivo
      codigo
      nombre_dispositivo
      asociado
      uuid
      estado_configuracion
      db_message
    }
  }
`;

export const CREATE_SCREEN_UPDATED = gql`
  mutation savePantallaUpdated(
    $nombre_pantalla: String!
    $descripcion_pantalla: String
    $codigo: String!
    $ubicacion: String!
    $zona_horaria: String!
    $canales: [FrecuenciaPantalla]
    $dias_reproduccion: [Int]
    $id_dispositivo: Int!
  ) {
    SavePantallaUpdated(
      nombre_pantalla: $nombre_pantalla
      descripcion_pantalla: $descripcion_pantalla
      codigo: $codigo
      ubicacion: $ubicacion
      zona_horaria: $zona_horaria
      canales: $canales
      dias_reproduccion: $dias_reproduccion
      id_dispositivo: $id_dispositivo
    ) {
      id_pantalla
      nombre_pantalla
      descripcion_pantalla
      codigo
      ubicacion
      latitud
      longitud
      zona_horaria
      activado
      fecha_conexion
      dispositivo {
        id_dispositivo
        codigo
        uuid
        tipo_dispositivo
        nombre_dispositivo
        capacidad_dispositivo
        estado_configuracion
        asociado
        db_message
        fecha_conexion
        reproduccion_activa
        id_estado_fk
        id_pantalla
        id_canal
        version_actual
        version_app
      }
      canales {
        id_canal
        nombre_canal
      }
      frecuencia
      estado {
        id_estado
        nombre_estado
        color
        id_estado_real
      }
      capturas {
        id_captura
      }
      db_message
    }
  }
`;

export const UPDATE_SCREEN_UPDATED = gql`
  mutation UpdatePantallaUpdated(
    $id_pantalla: Int!
    $nombre_pantalla: String!
    $descripcion_pantalla: String!
    $codigo: String!
    $ubicacion: String!
    $zona_horaria: String!
    $canales: [FrecuenciaPantalla]
    $dias_reproduccion: [Int]
  ) {
    UpdatePantallaUpdated(
      id_pantalla: $id_pantalla
      nombre_pantalla: $nombre_pantalla
      descripcion_pantalla: $descripcion_pantalla
      codigo: $codigo
      ubicacion: $ubicacion
      zona_horaria: $zona_horaria
      canales: $canales
      dias_reproduccion: $dias_reproduccion
    ) {
      id_pantalla
      canales {
        id_canal
        nombre_canal
        hora_inicio_pt
        hora_fin_pt
        orden
        descripcion_canal
        reproduccion_dia
        reproduccion_hora
        cantidad_pantallas
        fecha_creacion
        fecha_modificacion
        lista_reproduccion {
          id_lista
          codigo
        }
      }
      nombre_pantalla
      descripcion_pantalla
      codigo
      ubicacion
      latitud
      longitud
      zona_horaria
      activado
      fecha_conexion
      db_message
    }
  }
`;
